import { 
	ToolBox16,
	Report16,
} from '@carbon/icons';


export default [
	/* **** */
	{
		path: '/orders',
		redirect: '/orders/inwork',
		layout: 'Admin',
		meta: {
			name: 'Заказы',
			icon: ToolBox16,
			alert: 'requests',
		},
		menu: true,
		permissions: [ 'order_view' ],
		children: [
			{
				path: '/inwork',
				component: 'Orders',
				meta: {
					name: 'В работе',
				},
				menu: true,
				permissions: [ 'order_view' ],
			},
			{
				path: '/archive',
				component: 'OrdersArchive',
				meta: {
					name: 'Архив',
				},
				menu: true,
				permissions: [ 'order_view' ],
			},
			{
				path: '/tasks',
				component: 'Tasks',
				meta: {
					name: 'Задачи',
				},
				menu: true,
				permissions: [ 'order_view' ],
			},
			{
				path: '/minprices',
				component: 'Minprices',
				meta: {
					name: 'Ценовые распоряжения',
					binding: 'minprices_requests',
					alert: 'minprices_requests',
				},
				menu: true,
				permissions: [ 'order_view' ],
			},
			{
				path: '/mparchive',
				component: 'MinpricesArchive',
				meta: {
					name: 'Архив распоряжений',
				},
				menu: true,
				permissions: [ 'order_update' ],
			},
			{
				path: '/guarantees',
				component: 'Guarantees',
				meta: {
					name: 'Обеспечение заказов',
					binding: 'guarantees_requests',
					alert: 'guarantees_requests',
				},
				menu: true,
				permissions: [ 'order_view' ],
			},
			{
				path: '/:id',
				component: 'Order',
				meta: {
					name: 'Заказ',
				},
				permissions: [ 'order_view' ],
			},
		],
	},
	/* **** */
	/* {
		path: '/tasks',
		layout: 'Admin',
		component: 'Tasks',
		meta: {
			name: 'Задачи',
			icon: Report16,
		},
		menu: true,
		permissions: [ 'order_view' ],
	}, */
	/* **** */
];
